<template>
  <main style="background-color: #f5f5f5;">
    <!-- BANNER -->
    <div
      id="banner"
      :style="{
        'background-image':
          'url(' + require('@/assets/img/transparency/banner.jpg') + ')'
      }"
    >
      <div class="texto-banner">
        <h2 class="text-white text-3xl font-bold">Transparencia</h2>
        <p class="text-gray-100">Home / Transparencia</p>
      </div>
    </div>

    <!-- SECTION TRANSPARENCIA -->
    <section class="py-10">
      <!-- TABLE -->
      <div
        class="container mx-auto w-full md:w-3/4 p-4 md:p-10 bg-white rounded "
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <div class="bg-red-700 uppercase text-white rounded text-xl p-1 mb-6">
          <div class="flex justify-between mx-6 md:mx-20">
            <span>Título</span>
            <span>Ver</span>
          </div>
        </div>
        <!-- LIST 1 -->
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
              Revista CREDI YA 2023 Segunda Edición Aniversario 12 años.
            </h5>
          </div>
          <div class="right">
            <a
              href="https://drive.google.com/file/d/1IrmXFJ2LcIjeH4aJsOXkI4XQer63Ltka/view?usp=sharinga"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
        <!-- LIST 1.1 -->
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
              ESTATUTOS COOPERATIVA DE AHORRO Y CREDITO CREDI YA LTDA.
            </h5>
          </div>
          <div class="right">
            <a
              href="https://drive.google.com/file/d/1s3rDXGm9JWLBBU7Eoh-IrUutPGN9B2XT/view?usp=sharing"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
        <!-- LIST 1 -->
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
              BALANCE GENERAL 2024
            </h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/11BALANCEGENERAL2024.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>

        <!-- LIST 2 -->
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
              ESTADO DE RESULTADOS 2024
            </h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/14ESTADODEPERDIDASYGANANCIAS2023.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
        <!-- LIST 2 -->
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
              ANÁLISIS HORIZONTAL Y VERTICAL BALANCE GENERAL DICIEMBRE 2022 AL DICIEMBRE 2023
            </h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/12BALANCEGENERALDICIEMBRE2022ALDICIEMBRE2023.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
        <!-- LIST 2 -->
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
              ANÁLISIS HORIZONTAL Y VERTICAL BALANCE GENERAL DICIEMBRE 2023 AL DICIEMBRE 2024
            </h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/13BALANCEGENERALDICIEMBRE2023ALDICIEMBRE2024.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
        <!-- LIST 2 -->
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
             ANÁLISIS HORIZONTAL Y VERTICAL ESTADO DE RESULTADOS DICIEMBRE 2022 AL DICIEMBRE 2023
            </h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/13BALANCEGENERALDICIEMBRE2023ALDICIEMBRE2024.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
        <!-- LIST 2 -->
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
             ANÁLISIS HORIZONTAL Y VERTICAL ESTADO DE RESULTADOS DICIEMBRE 2023 AL DICIEMBRE 2024
            </h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/16ESTADODERESULTADOSDICIEMBRE2023ALDICIEMBRE2024.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
        
        <!-- LIST 2 -->
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
              POSICION DEL PATRIMONIO TÉCNICO 2023 - 2024
            </h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/17POSICIONDELPATRIMONIOTECNICO20232024.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>

        <!-- LIST 2 -->
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">COSTOS FINANCIEROS</h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/INFORMATIVOCREDIYA23012025.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
        <!-- LIST 2 -->
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">PERMISOS DE FUNCIONAMIENTO</h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/PermisosdeFuncionamientoAgencias.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
        <!-- LIST 2 -->
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
              INDICADORES DE GOBIERNO ACCESO A PRODUCTOS DE CRÉDITO
            </h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/2INDICADORESDEANEXO1ACCESOAPRODUCTOSDECREDITO.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
              INDICADORES DE GOBIERNO EDUCACIÓN FINANCIERA
            </h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/8INDICADORESDEGOBIERNOANEXO1EDUCACIONFINANCIERA.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
              INDICADORES DE GOBIERNO REPRESENTACIÓN
            </h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/9INDICADORESDEGOBIERNOANEXO1REPRESENTACIONDICIEMBRE2024.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
              INDICADORES DE GOBIERNO DE LA GERENCIA Y JEFATURAS DE ÁREAS
            </h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/4INDICADORESDEGOBIERNODELAGERENCIAYJEFATURASDEAREADELOSCOMITESYCOMISIONESDELOSEMPLEADOS.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
              INDICADORES DE GOBIERNO DE LOS RECLAMOS PRESENTADOS POR LOS
              USUARIOS
            </h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/6INDICADORESDEGOBIERNODELOSRECLAMOSPRESENTADOSPORLOSUSUARIOSDESERVICIOSFINANCIEROSANTELAENTIDADYSUPERINTENDENCIA.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
              INDICADORES DE GOBIERNO SOCIOS
            </h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/10INDICADORESDEGOBIERNOSOCIOSDICIEMBRE2024.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
              INDICADORES DE GOBIERNO DE LOS CONSEJOS DE ADMINISTRACIÓN Y
              VIGILANCIA
            </h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/5INDICADORESDEGOBIERNODELOSCONSEJOSDEADMINISTRACIONYVIGILANCIA.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
              INDICADORES DE GOBIERNO DE LA ASAMBLEA O JUNTA GENERAL
            </h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/3INDICADORESDEGOBIERNODELAASAMBLEAOJUNTAGENERAL.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
              INDICADORES DE GOBIERNO DEPÓSITOS POR GÉNERO MARZO 2022
            </h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/7INDICADORESDEGOBIERNOINFORMACIONDEPOSITOSPORGENERO2024.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
        <div class="container flex justify-between px-2 md:px-12 py-1">
          <div class="left flex">
            <img
              src="@/assets/img/transparency/icono.png"
              alt="icono crediya"
              class="mr-2"
              style="height:60px; margin: -15px"
            />
            <h5 class="uppercase text-lg gris">
              INDICADORES DE GENERO
            </h5>
          </div>
          <div class="right">
            <a
              href="https://procesostres.crediya.fin.ec/images/docs/1INDICADORESDEINCLUSIONFINANCIERACONPERSPECTIVASEGENERO.pdf"
              target="_blank"
              class="container bg-gray-100 px-10 rounded hover:bg-gray-300 hover:text-gray-500 cursor-pointer py-1"
            >
              <font-awesome-icon :icon="['fas', 'eye']" class="gris " />
            </a>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
export default {
  name: "WorkWithUs"
};
</script>

<style scoped>
#banner {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 350px;
  width: 100%;
  position: relative;
}
.texto-banner {
  position: absolute;
  left: 10%;
  top: 40%;
}
.texto-principal {
  position: absolute;
  left: 10%;
  top: 40%;
}
</style>
